module.exports = __webpack_public_path__ + "static/PP-90b57f1d28fa5bbdf6ec94f2749afab5.jpg";